export const MARKETING_V2_FLAG = process.env.NEXT_PUBLIC_MARKETING_V2 === 'true';

export const legacyMarketingNavLinks = [
  { href: '/', label: 'Home' },
  { href: '/discover', label: 'Discover Creators' },
  { href: '/chronicles', label: 'Chronicles' },
];

export const marketingV2NavLinks = [
  { href: '/', label: 'Home' },
  { href: '/discover', label: 'Discover Creators' },
  { href: '/chronicles', label: 'Chronicles' },
  { href: '/services', label: 'Services' },
  { href: '/sign-up', label: 'Sign Up' },
];

export const marketingNavAuthLinks = [
  { href: '/auth/login', label: 'Login' },
  { href: '/auth/signup', label: 'Sign Up' },
];
